import React, { useContext } from 'react';
import { Stack, Typography, Box, Grid } from '@mui/material';
import TPOPaper from '../../../components/TPOPaper/TPOPaper';
import ScorecardTabSection from './ScorecardTabSection';
import ScorecardChart from './ScorecardChart';
import Star from './star.svg';
import Edit from './edit.png';
import Circle from './circle.svg';
import BaseSummary from '../BaseSummary/BaseSummary';
import { CommentsContext } from '../../../common/commentsContext';
import { ReportContext } from '../../../common/reportContext';
import EditTextField from '../../../components/EditTextField/EditTextField';
import { currencyFormatting } from '../../../common/helpers';
import { emptyReport } from '../../../networking/analyses/report/Report';

const Scorecard = () => {
  const { comments, setComments } = useContext(CommentsContext);
  const { report, setReport } = useContext(ReportContext);

  const isReportSelected = report !== emptyReport;
  const periodStats = report.scorecard.periodStats[0];

  return (
    <Stack spacing={3}>
      <BaseSummary
        editable={true}
        title="Scorecard"
        content={comments.scoreCard.summary}
        setContent={(content) => {
          const newComments = { ...comments };
          newComments.scoreCard.summary = content;
          setComments(newComments);
        }}
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'stretch',
          gap: 3
        }}
      >
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            mr: 3
          }}
        >
          <ScorecardChart />
        </Box>
        <Box
          sx={{
            flex: '0 0 auto',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <TPOPaper color="rgba(70, 0, 116, 0.3)">
            <Box
              sx={{
                flexShrink: 0,
                padding: 3
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  padding: 3
                }}
              >
                <img src={Number(periodStats.value) >= 90 ? Star : Circle} />
                <Typography
                  sx={{
                    fontSize: '28px',
                    color: 'text.primary',
                    position: 'absolute',
                    marginTop: Number(periodStats.value) >= 90 ? '28px' : '18px'
                  }}
                >
                  {periodStats.value}
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: '32px',
                  color: 'text.primary',
                  textAlign: 'center',
                  marginBottom: '20px'
                }}
              >
                cashVest Score
              </Typography>

              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'auto auto',
                  columnGap: 2,
                  rowGap: 2,
                  alignItems: 'center',
                  width: 'fit-content'
                }}
              >
                <Typography sx={{ fontSize: '20px', fontWeight: 550, textAlign: 'right' }}>
                  {currencyFormatting(periodStats.periodInterest)}
                </Typography>
                <Typography sx={{ fontSize: '16px' }}>Period Interest</Typography>

                <Typography sx={{ fontSize: '20px', fontWeight: 550, textAlign: 'right' }}>
                  {currencyFormatting(periodStats.interestInLastYear)}
                </Typography>
                <Typography sx={{ fontSize: '16px' }}>Last 12 months</Typography>

                <Typography sx={{ fontSize: '20px', fontWeight: 550, textAlign: 'right' }}>
                  {currencyFormatting(periodStats.interestSinceAccountOpened)}
                </Typography>
                <Typography sx={{ fontSize: '16px' }}>Cumulative Interest</Typography>
              </Box>
            </Box>
          </TPOPaper>
        </Box>
      </Box>

      <ScorecardTabSection />

      <TPOPaper color="rgba(70, 0, 116, 0.3)">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row'
          }}
        >
          <Box
            sx={{
              width: '5px',
              backgroundColor: '#460074'
            }}
          />

          <Stack
            spacing={2}
            sx={{
              padding: 3,
              width: '100%'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <img src={Edit} width="50px" />
            </Box>
            <Typography
              sx={{
                fontSize: '32px',
                color: 'text.primary',
                textAlign: 'center'
              }}
            >
              Activities to help improve your cashVest Score
            </Typography>
            {/* TODO: refactor the improvement text boxes */}
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                gap: '16px'
              }}
            >
              <Stack
                sx={{
                  display: 'flex',
                  alignItems: 'center'
                }}
                spacing={2}
              >
                <Box
                  sx={{
                    height: '10px',
                    width: '10px',
                    backgroundColor: '#015545',
                    borderRadius: '50%'
                  }}
                />
                <EditTextField
                  placeholder={isReportSelected ? '' : undefined}
                  text={comments.scoreCard.improvement1}
                  setText={(text) => {
                    const newComments = { ...comments };
                    newComments.scoreCard.improvement1 = text;
                    setComments(newComments);
                  }}
                />
              </Stack>
              <Stack
                sx={{
                  display: 'flex',
                  alignItems: 'center'
                }}
                spacing={2}
              >
                <Box
                  sx={{
                    height: '10px',
                    width: '10px',
                    backgroundColor: '#015545',
                    borderRadius: '50%'
                  }}
                />
                <EditTextField
                  placeholder={isReportSelected ? '' : undefined}
                  text={comments.scoreCard.improvement2}
                  setText={(text) => {
                    const newComments = { ...comments };
                    newComments.scoreCard.improvement2 = text;
                    setComments(newComments);
                  }}
                />
              </Stack>
              <Stack
                sx={{
                  display: 'flex',
                  alignItems: 'center'
                }}
                spacing={2}
              >
                <Box
                  sx={{
                    height: '10px',
                    width: '10px',
                    backgroundColor: '#015545',
                    borderRadius: '50%'
                  }}
                />
                <EditTextField
                  placeholder={isReportSelected ? '' : undefined}
                  text={comments.scoreCard.improvement3}
                  setText={(text) => {
                    const newComments = { ...comments };
                    newComments.scoreCard.improvement3 = text;
                    setComments(newComments);
                  }}
                />
              </Stack>
              <Stack
                sx={{
                  display: 'flex',
                  alignItems: 'center'
                }}
                spacing={2}
              >
                <Box
                  sx={{
                    height: '10px',
                    width: '10px',
                    backgroundColor: '#015545',
                    borderRadius: '50%'
                  }}
                />
                <EditTextField
                  placeholder={isReportSelected ? '' : undefined}
                  text={comments.scoreCard.improvement4}
                  setText={(text) => {
                    const newComments = { ...comments };
                    newComments.scoreCard.improvement4 = text;
                    setComments(newComments);
                  }}
                />
              </Stack>
              <Stack
                sx={{
                  display: 'flex',
                  alignItems: 'center'
                }}
                spacing={2}
              >
                <Box
                  sx={{
                    height: '10px',
                    width: '10px',
                    backgroundColor: '#015545',
                    borderRadius: '50%'
                  }}
                />
                <EditTextField
                  placeholder={isReportSelected ? '' : undefined}
                  text={comments.scoreCard.improvement5}
                  setText={(text) => {
                    const newComments = { ...comments };
                    newComments.scoreCard.improvement5 = text;
                    setComments(newComments);
                  }}
                />
              </Stack>
              <Stack
                sx={{
                  display: 'flex',
                  alignItems: 'center'
                }}
                spacing={2}
              >
                <Box
                  sx={{
                    height: '10px',
                    width: '10px',
                    backgroundColor: '#015545',
                    borderRadius: '50%'
                  }}
                />
                <EditTextField
                  placeholder={isReportSelected ? '' : undefined}
                  text={comments.scoreCard.improvement6}
                  setText={(text) => {
                    const newComments = { ...comments };
                    newComments.scoreCard.improvement6 = text;
                    setComments(newComments);
                  }}
                />
              </Stack>
            </Box>
          </Stack>
        </Box>
      </TPOPaper>
    </Stack>
  );
};

export default Scorecard;
